angular.module('ordersSearch', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/orders-search/orders-search.module.js